var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(this.$store.getters.breadcrumbs.length > 0)?_c('v-breadcrumbs',{attrs:{"items":this.$store.getters.breadcrumbs}}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }